// The chat assistants the transcript panel can hand a transcript to.
//
// None of them can take the transcript in the URL: transcripts reach 87KB and
// browsers and servers truncate a query string long before that, silently. So
// each button copies the transcript and opens a fresh chat to paste into.
// LCATOMICZO-66 (Claude), LCCRM-88 (ChatGPT).
export type AskAssistant = { key: string; name: string; url: string };

export const ASK_ASSISTANTS: AskAssistant[] = [
  { key: "claude", name: "Claude", url: "https://claude.ai/new" },
  { key: "chatgpt", name: "ChatGPT", url: "https://chatgpt.com/" },
];

type PlatformNavigator = {
  platform?: string;
  userAgentData?: { platform?: string };
};

/** The paste shortcut to tell the user about: ⌘V on a Mac, Ctrl+V elsewhere. */
export const pasteShortcut = (
  nav: PlatformNavigator | undefined = typeof navigator === "undefined"
    ? undefined
    : (navigator as PlatformNavigator),
): string => {
  const platform = nav?.userAgentData?.platform || nav?.platform || "";
  return /mac/i.test(platform) ? "⌘V" : "Ctrl+V";
};
